import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {OrdersService} from '../../services/orders.service';
import {ResendWebidModel} from '../../../models/resend-webid-model';
import {CompanyService} from '../../services/company.service';
import {Company} from '../../../dto/company';
import {TemplateSendPreviewModel} from '../../../models/template-send-preview-model';

@Component({
  selector: 'app-template-send-preview-dialog',
  templateUrl: './template-send-preview-dialog.component.html',
  styleUrls: ['./template-send-preview-dialog.component.css']
})
export class TemplateSendPreviewDialogComponent implements OnInit {

  public title = 'Send Preview';
  public text = 'Please enter the e-mail address';


  public email: string;
  public companies: Company[] = [];
  private templateId: number;
  public company: Company;
  isLoadingCompanies = false;


  constructor(
    public dialogRef: MatDialogRef<TemplateSendPreviewDialogComponent>,
    private companiesService: CompanyService,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  private loadCompanies() {
    this.isLoadingCompanies = true;
    this.companiesService.getAll().subscribe(x => {
      this.companies = x.data;
      this.isLoadingCompanies = false;
    });
  }

  ngOnInit() {

    if (this.data != null) {
      this.email = this.data.email;
      this.templateId = this.data.templateId;
      this.loadCompanies();
    }
  }

  onYesClick(): void {

    const model = new TemplateSendPreviewModel();
    model.email = this.email;
    model.templateId = this.templateId;
    model.companyId = this.company.id;

    this.dialogRef.close(model);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
